import React, { Component } from 'react';


import { observable, computed } from 'mobx';
import { observer, inject } from 'mobx-react'
@inject("store")
@observer
class PersonalDetails extends Component {

	@observable error = false
	@observable errorText = "Please fill the name"

	componentDidMount() {
		this.props.store.step = 0
	}

	@computed get completed() {
		const { doctor } = this.props.store

		if (!(doctor.title)) { return false  }
		if (!doctor.gender) { return false  }
		if (!(doctor.fname)) { return false }
		if (!(doctor.lname)) { return false }
		if (!(doctor.qualification)) { return false }
		
		return true
	}

	handleNext = () => {
		// Checklist
		if (!this.completed) { this.error = true;return  }
		
		// Complete
		this.props.history.push(`/listing/new/${this.props.store.step + 2}`)
		this.props.store.nextStep()
	}

	render() {
		const { doctor } = this.props.store
		return (
			<div>

				<h2 >1. Personal Details</h2>
				<p className="m-t-1 special" >
					Only registered medical practitioners may list with GPbook. You must hold the relevant qualifications to the specialty you are registering. By completing and submitting this form you acknowledge that the information you are providing is true and correct. GPbook reserves the right to verify, alter or decline submissions. If you are unsure whether you qualify please email info@gpbook.com.au with your query first.
				</p>
				<h4
					className={`${this.error && 'error'} ${this.error && doctor.title && 'complete'}`}
				>Title:</h4>	
				<input
					className={`input small ${this.error && 'error'} ${this.error && doctor.title && 'complete'}`}
					type="text"
					placeholder="Dr, Prof, Mr, Mrs, Ms, Miss etc"
					value={doctor.title}
					autoFocus
					onChange={e => doctor.title = e.target.value}
				/>
				
				<h4
					className={`${this.error && 'error'} ${this.error && doctor.gender && 'complete'}`}
				>Gender	:</h4>	
				
				<div className="select-option">
					<div className="btn-group" >
						
						<button
							type="button"
							onClick={e => doctor.gender = "Male"}
							className={`btn ${doctor.gender === "Male" || "white"}`}>
							<i className="fa fa-male"></i>
							Male
						</button>
						
						<button
							type="button"
							onClick={e => doctor.gender = "Female"}
							className={`btn ${doctor.gender === "Female" || "white"}`}>
							<i className="fa fa-female"></i>
							Female
						</button>
					
					</div>
				</div>
				
				<h4 className={`${this.error && "error"} ${this.error && doctor.fname && 'complete'}`}>First Name:
				</h4>	
				<input
					type="text"
					placeholder="John"
					className={`input medium ${this.error && 'error'} ${this.error && doctor.fname && 'complete'}`}
					value={doctor.fname}
					onChange={e => doctor.fname = e.target.value} />
				
				<h4 className={`${this.error && "error"} ${this.error && doctor.lname && 'complete'}`}>Last Name:
				</h4>	
				<input
					type="text"
					placeholder="Smith"
					className={`input medium ${this.error && 'error'} ${this.error && doctor.lname && 'complete'}`}
					value={doctor.lname}
					onChange={e => doctor.lname = e.target.value} />

				<h4>Registered College(s):</h4>	
				<input
					type="text"
					placeholder="Registered Specialty College(s)"
					className="input"
					value={doctor.college}
					onChange={e => doctor.college = e.target.value}
				/>

				<h4 className={`${this.error && "error"} ${this.error && doctor.qualification && 'complete'}`}>Credentials:</h4>	
				<input
					type="text"
					placeholder="eg: MBBS, FRACS"
					className={`input medium ${this.error && 'error'} ${this.error && doctor.qualification && 'complete'}`}
					value={doctor.qualification}
					onChange={e => doctor.qualification = e.target.value}
				/>


				<div className="m-t-1">
					<div
						onClick={this.handleNext}	
						className={`btn ${!this.completed && 'disabled'}`}><i className="fa fa-fw fa-arrow-right"></i> Next</div>
				</div>
				
			</div>
		);
	}
}

export default PersonalDetails;


// WEBPACK FOOTER //
// ./src/Containers/Listing/1.PersonalDetails.js